import React from 'react';

import IMG_SLICK from 'assets/images/logos/slick-logo-text.png';
import Button from 'components/form/Button.component';
import FormError from 'components/form/FormError.component';
import { useTranslation } from 'providers/GILT.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './ResetErrorPanel.module.scss';

const ResetErrorPanel = ({ tag: tagFromProps, onNext, error, subtitle }) => {
  const { t } = useTranslation();
  const tag = fromAnyToTrimmed(tagFromProps);
  return (
    <div data-bem="ResetErrorPanel" className={CN.component} tag={tag}>
      <img src={IMG_SLICK} alt="Slick logo" className={CN.logo} />
      <div className={CN.title}>{t('forgotPassword.resetErrorModal.title')}</div>
      <div className={CN.subTitle}>{subtitle}</div>

      <FormError value={error} />

      <div className={CN.buttonContainer}>
        <Button variant="primaryForce" width="max" height="max" onClick={onNext}>
          <span className={CN.buttonFont}>{t('forgotPassword.resetErrorModal.nextButton')}</span>
        </Button>
      </div>
    </div>
  );
};

export default ResetErrorPanel;
